// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/legacy_portal_error.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
/**
 * @generated from enum spwn.dashboard.v1.EventRoleAuthorizationErrorReason
 */
export var EventRoleAuthorizationErrorReason;
(function (EventRoleAuthorizationErrorReason) {
    /**
     * @generated from enum value: EVENT_ROLE_AUTHORIZATION_ERROR_REASON_UNSPECIFIED = 0;
     */
    EventRoleAuthorizationErrorReason[EventRoleAuthorizationErrorReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 対象リソースへの操作に必要なロール（権限）が不足している
     *
     * @generated from enum value: EVENT_ROLE_AUTHORIZATION_ERROR_REASON_INSUFFICIENT_ROLE = 1;
     */
    EventRoleAuthorizationErrorReason[EventRoleAuthorizationErrorReason["INSUFFICIENT_ROLE"] = 1] = "INSUFFICIENT_ROLE";
})(EventRoleAuthorizationErrorReason || (EventRoleAuthorizationErrorReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(EventRoleAuthorizationErrorReason)
proto3.util.setEnumType(EventRoleAuthorizationErrorReason, "spwn.dashboard.v1.EventRoleAuthorizationErrorReason", [
    { no: 0, name: "EVENT_ROLE_AUTHORIZATION_ERROR_REASON_UNSPECIFIED" },
    { no: 1, name: "EVENT_ROLE_AUTHORIZATION_ERROR_REASON_INSUFFICIENT_ROLE" },
]);
/**
 * イベント権限認可済みのユーザがアクセスした際のエラー
 *
 * @generated from message spwn.dashboard.v1.EventRoleAuthorizationError
 */
export class EventRoleAuthorizationError extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: spwn.dashboard.v1.EventRoleAuthorizationErrorReason reason = 1;
         */
        this.reason = EventRoleAuthorizationErrorReason.UNSPECIFIED;
        /**
         * エラーの概要（例: "必要な権限が不足しています"）
         *
         * @generated from field: string message = 2;
         */
        this.message = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventRoleAuthorizationError().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventRoleAuthorizationError().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventRoleAuthorizationError().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventRoleAuthorizationError, a, b);
    }
}
EventRoleAuthorizationError.runtime = proto3;
EventRoleAuthorizationError.typeName = "spwn.dashboard.v1.EventRoleAuthorizationError";
EventRoleAuthorizationError.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "enum", T: proto3.getEnumType(EventRoleAuthorizationErrorReason) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=legacy_portal_error_pb.js.map